import { render, staticRenderFns } from "./itemTree.vue?vue&type=template&id=581fdee6"
import script from "./itemTree.vue?vue&type=script&lang=js"
export * from "./itemTree.vue?vue&type=script&lang=js"
import style0 from "./itemTree.vue?vue&type=style&index=0&id=581fdee6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports